import { builder, defaults } from 'common/js/configs';
import { units } from 'common/js/configs/constants';

const mainCloseBtnConfig = {
  paddingSize: builder.number('close_btn_padding_size', {
    defaultValue: 3,
    l:'',
    d:'',
    unit: units.pixel
  }),
  largeClickableZonePadding: builder.number(
    'close_btn_large_clickable_zone_padding',
    {
      defaultValue: 0,
      l:'',
      d:'',
      unit: units.pixel
    }
  ),
  displayAfter: builder.number('close_btn_display_after', {
    defaultValue: 3,
    l:'',
    d:'',
    min: 0,
    max: 3,
    unit: units.seconds
  }),
  iconColor: builder.color('close_btn_icon_color', {
    defaultValue: '#FFFFFF',
    l:'',
    d:''
  }),
  autoCloseAfter: builder.number('auto_close_display_after', {
    defaultValue: 0,
    l:'',
    d:'',
    unit: units.seconds
  }),
  useCountdownCloseButton: builder.boolean('use_close_btn_countdown', {
    defaultValue: true,
    l:'',
    d:''
  }),
  legacyUseCountdownCloseButton: builder.boolean('close_btn_countdown_use', {
    defaultValue: true,
    l:'',
    d:''
  })
};

const getRoundedButtonConfig = (extraClickableZoneValue: number = 0) => {
  return {
    fontColor: builder.color('close_btn_countdown_font_color', {
      defaultValue: '#C1C1C1',
      l:'',
      d:''
    }),

    circleColor: builder.color('close_btn_countdown_circle_color', {
      defaultValue: '#C1C1C1',
      l:'',
      d:''
    }),
    offsetY: defaults.closeBtnOffsetY,
    extraClickableZone: builder.number('close_btn_extra_clickable_zone', {
      defaultValue: extraClickableZoneValue,
      unit: units.pixel
    }),
    paddingSize: builder.number('close_btn_padding_size', {
      defaultValue: 0,
      l:'',
      d:'',
      unit: units.pixel,
      min: 0,
      max: 8
    })
  };
};

const getBtnConfig = (
  defaultUseValue: boolean,
  type: 'rounded' | 'squared',
  defaultPosition: 'left' | 'right',
  extraClickableZoneValue: number = 0
) => {
  return {
    ...mainCloseBtnConfig,
    useCloseBtn: builder.boolean('use_close_btn', {
      defaultValue: defaultUseValue,
      l:'',
      d:''
    }),
    type: builder.string('close_btn_type', {
      of: ['rounded', 'squared'],
      possibleValues: [
        {
          name: 'Rounded',
          value: 'rounded'
        },
        {
          name: 'Squared',
          value: 'squared'
        }
      ],
      defaultValue: type,
      l:'',
      d:''
    }),
    iconColor: builder.color('close_btn_icon_color', {
      defaultValue: type === 'rounded' ? '#C1C1C1' : '#FFFFFF',
      l:'',
      d:''
    }),
    iconSize: builder.number('close_btn_size', {
      defaultValue: type === 'rounded' ? 30 : 10,
      l:'',
      d:'',
      unit: units.pixel
    }),
    position: builder.string('close_btn_position', {
      of: ['right', 'left'],
      possibleValues: [
        {
          name: 'Left',
          value: 'left'
        },
        {
          name: 'Right',
          value: 'right'
        }
      ],
      defaultValue: defaultPosition,
      l:'',
      d:''
    }),
    ...(type === 'rounded'
      ? getRoundedButtonConfig(extraClickableZoneValue)
      : {})
  };
};

export const commonUseCloseBtnSquared = {
  closeBtn: builder.holder({
    ...getBtnConfig(true, 'squared', 'left')
  })
};

export const leftUseCloseBtnRounded = {
  closeBtn: builder.holder({
    ...getBtnConfig(true, 'rounded', 'left', 4)
  })
};

export const rightUseCloseBtnRounded = {
  closeBtn: builder.holder({
    ...getBtnConfig(true, 'rounded', 'right', 0)
  })
};
